import { memo } from "react";
import { getSmoothStepPath } from "@xyflow/react";
import type { EdgeProps } from "@xyflow/react";

interface CalculationEdgeData extends Record<string, unknown> {
  isOnVariancePath: boolean;
  isHighlighted: boolean;
}

type CalculationEdgeProps = EdgeProps & { data?: CalculationEdgeData };

export const CalculationEdge = memo(function CalculationEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}: CalculationEdgeProps) {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const isVariance = data?.isOnVariancePath ?? false;
  const isHighlighted = data?.isHighlighted ?? false;

  let stroke = "#d1d5db";
  let strokeWidth = 1.5;

  if (isVariance) {
    stroke = "#ef4444";
    strokeWidth = 3;
  } else if (isHighlighted) {
    stroke = "#3b82f6";
    strokeWidth = 2.5;
  }

  return (
    <path
      id={id}
      d={edgePath}
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      style={{ transition: "stroke 0.15s ease, stroke-width 0.15s ease" }}
    />
  );
});
